import { UserType } from "features/client/types";

const isUserPaid = (user: UserType | null): boolean => {
  if (!user) return true
  if (!user.client.latest_order) return false;

  const contract_end_date = new Date(user.client.latest_order.contract_end_date);
  const now = new Date();
  return contract_end_date > now;
}

export default isUserPaid;